<div class="pane-header">
  <h3 class="title"></h3>
  <div class="actions">
    <span class="close">
      {{{ icon 'close' 'Close' }}}
    </span>
  </div>
</div>
<div class="pane-body"></div>
<div class="pane-footer"></div>
